import styled from "styled-components";

export const HeaderScrolledContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: 1400px;
  width: 100%;
  align-self: center;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex: 1 1 auto;
  min-width: 0;
  justify-content: space-between;
  padding: 0 16px 0 0;
`;

export const HeaderScrolledLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

export const HeaderScrolledRight = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
`;

export const TagsGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const TagSeparator = styled.span`
  color: #5c5c5c;
  font-size: 12px;
  user-select: none;
`;
